import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeUIProvider, useColorMode, useThemeUI } from 'theme-ui';
import App from './App';
import './index.css';
import initStore from './store';
import theme from './theme';

const queryClient = new QueryClient()
const RootComponent = () => {
  // Hook to apply the background color dynamically
  const { theme: themeUI } = useThemeUI();
  const [colorMode, setColorMode] = useColorMode();
  // if ('serviceWorker' in navigator) {
  //   window.addEventListener('load', () => {
  //     navigator.serviceWorker
  //       .register('/firebase-messaging-sw.js')
  //       .then((registration) => {
  //         console.log('Service Worker registered with scope:', registration.scope);
  //       })
  //       .catch((error) => {
  //         console.error('Service Worker registration failed:', error);
  //       });
  //   });
  // }

  React.useEffect(() => {
    const backgroundColor =
      typeof themeUI?.colors?.background === 'string' ? themeUI.colors.background : '#fff';
    document.body.style.backgroundColor = backgroundColor;
  }, [themeUI?.colors?.background]);

  React.useEffect(() => {
    if (!colorMode) {
      setColorMode('light');
      document.documentElement.setAttribute('data-theme', 'light');
    } else {
      document.documentElement.setAttribute('data-theme', colorMode);
    }
  }, [colorMode, setColorMode]);

  return (

    <App />

  );
};
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.Fragment>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Provider store={initStore}>
          <ThemeUIProvider theme={theme}>
            {/* <div data-theme={useColorMode}> */}
            <RootComponent />
            {/* </div> */}
          </ThemeUIProvider>
        </Provider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.Fragment>
);
